import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchProductsByTitleId } from "../../api/productService";
import { formatCollectionName } from "../../utils/collectionDisplayUtils";
import { findIssnMediumGaps, ISSN_REQUEST_URL, } from "../../utils/issnMediumWarning";
import { InfoBox, InfoBoxTypeEnum } from "../InfoBox";
/**
 * Informative, never blocking warning (DB-787, NKP #747 note_67884): the title has both a print and an
 * electronic product, but its Series or edition carries an ISSN of one medium only - attach the ISSN of the
 * other medium too, or request one from the ISSN centre. Shares the `["products", titleId]` query with the
 * products panel.
 */
export var TitleIssnMediumWarning = function (_a) {
    var titleId = _a.titleId, titleCollections = _a.titleCollections;
    var ky = useOkapiKy();
    var productsData = useQuery(["products", titleId], function () { return fetchProductsByTitleId(ky, titleId); }, { enabled: !!titleId }).data;
    var gaps = useMemo(function () { return findIssnMediumGaps(titleCollections, productsData === null || productsData === void 0 ? void 0 : productsData.items); }, [titleCollections, productsData]);
    if (gaps.length === 0)
        return null;
    return (React.createElement(InfoBox, { type: InfoBoxTypeEnum.WARNING, titleId: "ui-br-agency.title.issnMediumWarning.title" },
        gaps.map(function (gap) { return (React.createElement("div", { key: gap.type },
            React.createElement(FormattedMessage, { id: "ui-br-agency.title.issnMediumWarning.".concat(gap.type, ".").concat(gap.coveredMedium), values: {
                    names: gap.collections.map(formatCollectionName).join(", "),
                    count: gap.collections.length,
                } }))); }),
        React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.title.issnMediumWarning.request", values: {
                    a: function (chunks) { return (React.createElement("a", { href: ISSN_REQUEST_URL, target: "_blank", rel: "noopener noreferrer" }, chunks)); },
                } }))));
};
